import React, { useEffect, useRef, useState } from 'react';
import '../../../style/UserManagement.css';
import { FaUser } from 'react-icons/fa';
import { ReactComponent as SearchMagnifyIcon } from '../../../assets/svg/SearchMagnifyIcon.svg';
import VerticalOptionsButton from './VerticalOptionsButton';
import UserProfileModal from './UserProfileModal';
// import CreateEditUserModal from './CreateEditUserModal';
// import FilterUserComponent from './FilterUserComponent';
import InfiniteScroll from 'react-infinite-scroll-component';
import Loading from '../../../utils/Loading';
import ConfirmationModal from './ConfirmationModal';
import FilterUserComponent from './FilterUserComponent';
import { getSubscriptionCatalog, getUsers } from '../../../server/server';
import ChangeSubscriptionModal from './ChangeSubscriptionModal';
import { format } from 'date-fns';
import { sr } from 'date-fns/locale';
import { useNavigate } from 'react-router-dom';

const limit = 20;

function UserManagement() {
    const [users, setusers] = useState<any[]>([]);
    const navigate = useNavigate();
    const totalUsers = useRef(0);
    const [searchText, setSearchText] = useState('');
    const [loading, setLoading] = useState(true);
    const timeout = useRef<any>(null);
    const [userProfileModalOpen, setUserProfileModalOpen] = useState(false);
    const [selectedUser, setSelectedUser] = useState(null);

    const [changeSubscriptionModal, setChangeSubscriptionModal] = useState(false);
    const [loadingMore, setLoadingMore] = useState(false);
    const [resultsNum, setResultsNum] = useState(0);
    const [hasMore, setHasMore] = useState(true);
    const isFirstMount = useRef(true);
    const [valid, setValid] = useState<any>('');
    const [subscription, setSubscription] = useState('');

    useEffect(() => {
        if (isFirstMount.current) {
            isFirstMount.current = false;
            return;
        }
        if (resultsNum === 0) loadUsers();
        else setResultsNum(0);
    }, [valid, subscription]);

    useEffect(() => {
        console.log('resultsNum ', resultsNum);
        loadUsers();
    }, [resultsNum]);

    const loadUsers = async (searchTerm: string = searchText) => {
        if (resultsNum === 0) setLoading(true);
        else setLoadingMore(true);
        const resp = await getUsers(limit, resultsNum, searchTerm, subscription, valid);
        if (resp.status == 200) {
            const data = resp.data?.items;
            const total = resp.data?.total;
            totalUsers.current = resp.data?.total;
            if (resultsNum === 0) {
                setusers(data);
                setHasMore(total > data?.length);
            } else {
                setHasMore(total > users.length + data?.length);
                setusers((prev: any) => [...prev, ...data]);
            }
            setLoadingMore(false);
            setLoading(false);
        } else {
            setLoading(false);
        }
    };

    const setValidFilter = (typeFilter: string) => {
        if (typeFilter === 'svi') setValid('');
        else if (typeFilter === 'validan') setValid(true);
        else if (typeFilter === 'nevalidan') setValid(false);
    };

    // const setSubFilter = (subFilter: string) => {
    // 	if (subFilter === 'all') setSubscription('');
    // 	else {
    // 		setSubscription(subFilter);
    // 	}
    // };

    const openUserProfileModal = (user: any) => {
        setSelectedUser(user);
        setUserProfileModalOpen(true);
    };

    const openFinanceCard = (user: any) => {
        navigate(`/admin/finance/${user.id}`);
    };

    const closeUserProfileModal = () => {
        setUserProfileModalOpen(false);
    };

    const reloadList = () => {
        if (resultsNum === 0) loadUsers();
        else setResultsNum(0);
    };

    const removeUser = () => {
        setUserProfileModalOpen(false);
        console.log('remove user ', selectedUser);
    };

    const handleChange = (e: any) => {
        e.preventDefault();
        setSearchText(e.target.value);
        if (timeout !== null) {
            clearTimeout(timeout.current);
        }
        timeout.current = setTimeout(() => {
            if (resultsNum === 0) loadUsers(e.target.value);
            else setResultsNum(0);
        }, 700);
    };
    return (
        <div id="scroll-inf-task" className="flex h-full flex-col items-center overflow-y-auto bg-[#ECEBF8] py-[10px]">
            <div className=" w-full h-full  max-w-[1200px] px-[10px]">
                <div className="w-full min-h-full  bg-white flex flex-col px-[40px] py-[30px] rounded-[6px]">
                    <div>
                        <p className="text-gray900 font-bold text-[24px] leading-7">Upravljanje korisnicima</p>
                        <div className="mt-8 flex flex-row items-center">
                            <p className="text-gray900 font-bold text-[20px] leading-6">Ukupno korisnika</p>
                            <p className="flex-1 text-gray600 font-bold text-[20px] leading-6 ml-2">{totalUsers.current}</p>
                            <div className="flex flex-row items-center rounded-full border border-primaryViolet  py-[7px] min-w-[300px] px-4">
                                <input
                                    type="text"
                                    placeholder="Pretraži"
                                    value={searchText}
                                    onChange={(e: any) => handleChange(e)}
                                    className="h-full flex-1 outline-none  text-primaryViolet font-medium text-[14px] leading-5 placeholder:font-medium placeholder:text-gray600"
                                    autoComplete="off"
                                />
                                <SearchMagnifyIcon width={18} height={18} color="#475467" />
                            </div>

                            <div className="ml-3">
                                <FilterUserComponent
                                    value={valid}
                                    selectedOption="Svi"
                                    setValue={setValidFilter}
                                    width={140}
                                    height={34}
                                    options={['svi', 'validan', 'nevalidan']}
                                    isCapitalize
                                />
                            </div>
                            {/* <div className='ml-3'>
								<FilterUserComponent value={subscription} selectedOption='subscription' setValue={setSubFilter} width={140} height={34} options={subscriptions} isCapitalize />
							</div> */}
                            {/* <div
								className={`cursor-pointer flex  min-w-[140px] py-[6px] px-3 ml-3 items-center justify-center rounded-full border border-primaryViolet
									bg-white text-[14px] leading-5  font-medium text-primaryViolet transition  hover:bg-primaryViolet hover:text-brandYellow`}
								onClick={() => openCreateUserModal(null)}
							>
								Add new user
							</div> */}
                        </div>
                    </div>
                    {users.length === 0 && !loading && (
                        <div className="flex w-full flex-grow  items-center justify-center">
                            <p className="text-center text-[14px] font-medium leading-5 text-mudPurple">
                                This list is empty right now.
                                <br /> Consider adding new users...
                            </p>
                        </div>
                    )}
                    {!loading && users.length !== 0 && (
                        <InfiniteScroll
                            dataLength={users.length}
                            next={() => {
                                setResultsNum(users.length);
                            }}
                            hasMore={hasMore}
                            scrollableTarget="scroll-inf-task"
                            inverse={false}
                            loader={undefined}
                        >
                            <table className="custom-table my-6 ">
                                <thead>
                                    <tr>
                                        <th style={{ borderTopLeftRadius: 8, borderBottomLeftRadius: 8 }}>
                                            <p className="text-gray600 font-semibold text-[14px] leading-5">Korisničko ime</p>
                                        </th>
                                        <th>
                                            <p className="text-gray600 font-semibold text-[14px] leading-5">Validan</p>
                                        </th>
                                        <th>
                                            <p className="text-gray600 font-semibold text-[14px] leading-5">Važenje pretplate</p>
                                        </th>
                                        <th>
                                            <p className="text-gray600 font-semibold text-[14px] leading-5">Jedinstveni broj</p>
                                        </th>
                                        <th>
                                            <p className="text-gray600 font-semibold text-[14px] leading-5">Datum kreiranja</p>
                                        </th>
                                        <th style={{ borderTopRightRadius: 8, borderBottomRightRadius: 8, textAlign: 'center' }}>
                                            <p className="text-gray600 font-semibold text-[14px] leading-5">Akcije</p>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {users.map((user: any, index: number) => (
                                        <tr key={index}>
                                            <td>
                                                <div className="flex flex-row items-center gap-3">
                                                    <div className="min-w-[40px] h-[40px] rounded-full bg-grey-400 border border-gray600 flex items-center justify-center">
                                                        <FaUser width={30} height={30} color="white" />
                                                    </div>
                                                    <div>
                                                        <p className="text-gray900 font-medium text-[14px] leading-5">{user.username}</p>
                                                        <p className="text-gray600 font-normal text-[14px] leading-5">{user.email}</p>
                                                    </div>
                                                </div>
                                            </td>
                                            <td>
                                                <p className="text-gray600 font-normal text-[14px] leading-5">{user.valid ? 'Validan' : 'Nije validan'}</p>
                                            </td>
                                            <td>
                                                <p className="text-gray600 font-normal text-[14px] leading-5">{format(user.endDate, 'dd.MMM.yyyy')}</p>
                                            </td>
                                            <td>
                                                <p className="text-gray600 font-normal text-[14px] leading-5">{user.uniqueNumber}</p>
                                            </td>
                                            <td>
                                                <p className="text-gray600 font-normal text-[14px] leading-5">{format(user.createdAt, 'dd.MMM.yyyy')}</p>
                                            </td>
                                            <td>
                                                <VerticalOptionsButton
                                                    openUserProfileModal={openUserProfileModal}
                                                    openFinanceCard={openFinanceCard}
                                                    user={user}
                                                />
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </InfiniteScroll>
                    )}
                    {loading && (
                        <div className="flex w-full flex-grow items-center justify-center">
                            <Loading size={70} primaryColor="#5E639B" stroke={3} />
                        </div>
                    )}
                </div>
            </div>
            <UserProfileModal modalIsOpen={userProfileModalOpen} closeModal={closeUserProfileModal} user={selectedUser} reloadList={reloadList} />
        </div>
    );
}

export default UserManagement;
